var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdjustTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33337 11.8841C2.33337 6.42526 6.75863 2 12.2175 2C16.3092 2 19.8201 4.48625 21.3221 8.03043C21.5626 8.59778 21.1175 9.18842 20.5013 9.18842C20.1075 9.18842 19.7613 8.93782 19.6002 8.57855C18.3364 5.76022 15.5062 3.79711 12.2175 3.79711C7.75115 3.79711 4.13048 7.41777 4.13048 11.8841C4.13048 15.4766 6.473 18.522 9.7139 19.5761C10.1215 19.7087 10.4203 20.0749 10.4203 20.5035C10.4203 21.0768 9.8985 21.5118 9.34982 21.3458C5.28943 20.1168 2.33337 16.3456 2.33337 11.8841ZM21.0506 11.9914C20.8795 12.0623 20.7241 12.1662 20.5932 12.2971L19.8457 13.0445L21.8396 15.0385L22.5871 14.291C22.718 14.1601 22.8219 14.0047 22.8927 13.8336C22.9636 13.6625 23.0001 13.4792 23.0001 13.294C23.0001 13.1089 22.9636 12.9255 22.8927 12.7545C22.8219 12.5834 22.718 12.428 22.5871 12.2971C22.4562 12.1662 22.3008 12.0623 22.1297 11.9914C21.9586 11.9206 21.7753 11.8841 21.5901 11.8841C21.405 11.8841 21.2217 11.9206 21.0506 11.9914ZM20.7631 16.115L18.7692 14.1211L13.8637 19.0266L13.332 20.976C13.2365 21.3263 13.5579 21.6477 13.9082 21.5521L15.8576 21.0205L20.7631 16.115ZM12.2174 5.59423C12.7137 5.59423 13.116 5.99653 13.116 6.49279V11.3288L15.4098 12.4757C15.8537 12.6976 16.0336 13.2374 15.8117 13.6812C15.5897 14.1251 15.05 14.305 14.6061 14.0831L11.8156 12.6878C11.5112 12.5356 11.3189 12.2245 11.3189 11.8841V6.49279C11.3189 5.99653 11.7212 5.59423 12.2174 5.59423Z",
    fill: "url(#paint0_linear_735_3185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_735_3185",
    x1: 10.6581,
    y1: 21.5692,
    x2: 14.2736,
    y2: 1.92606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustTime);
export default __webpack_public_path__ + "static/media/AdjustTime.8ae5846227396a2ab2b14acdc9a2d0a9.svg";
export { ForwardRef as ReactComponent };